import { render, staticRenderFns } from "./StaticMap.vue?vue&type=template&id=b408e2d2&scoped=true&"
import script from "./StaticMap.vue?vue&type=script&lang=js&"
export * from "./StaticMap.vue?vue&type=script&lang=js&"
import style0 from "./StaticMap.vue?vue&type=style&index=0&id=b408e2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b408e2d2",
  null
  
)

export default component.exports